/* Saç Qaraldıcı — tək məhsul səhifəsi (v2) */
(() => {
  const fmt = (cents) => {
    const c = Math.round(cents || 0);
    return Math.floor(c / 100) + ',' + String(c % 100).padStart(2, '0') + ' ₼';
  };
  const norm = (s) => String(s == null ? '' : s).trim().toLocaleLowerCase('az');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.querySelectorAll('.sq-site').forEach((site) => {
    const sid = site.dataset.sectionId;
    const dataEl = document.getElementById('sq-data-' + sid);
    if (!dataEl) return;

    const $ = (s) => site.querySelector(s);
    const $$ = (s) => [...site.querySelectorAll(s)];
    const D = JSON.parse(dataEl.textContent);
    const variants = D.variants || [];

    const colorInputs = $$('input[name^="sq-color-"]');
    const packInputs = $$('input[name^="sq-pack-"]');
    const packCards = $$('.sq-pack');
    const orderBtn = $('#sq-order');
    const feedback = $('#sq-feedback');

    const selectedColor = () => (colorInputs.find((i) => i.checked) || colorInputs[0]).value;
    const selectedPackCard = () => packCards.find((c) => c.querySelector('input').checked) || packCards[packCards.length - 1];
    const countOf = (card, idx) => parseInt(card.dataset.value, 10) || idx + 1;

    // Seçilən rəngə uyğun variantlar
    const variantsForColor = (color) => {
      if (!D.colorPos) return variants;
      const m = variants.filter((v) => norm(v.options[D.colorPos - 1]) === norm(color));
      return m.length ? m : variants;
    };

    // Bir paket kartı üçün qiymət məlumatı
    const infoFor = (card, idx, color) => {
      const list = variantsForColor(color);
      const count = countOf(card, idx);
      if (D.packPos) {
        const v = list.find((x) => norm(x.options[D.packPos - 1]) === norm(card.dataset.value)) || null;
        const price = v ? v.price : 0;
        const was = v && v.compare_at_price && v.compare_at_price > price ? v.compare_at_price : 0;
        return { v, qty: 1, count, price, was };
      }
      const v = list[0] || variants[0] || null;
      const unit = v ? v.price : 0;
      const full = unit * count;
      const deal = count === 2 && D.bundleCents > 0 && D.bundleCents < full;
      return { v, qty: count, count, price: deal ? D.bundleCents : full, was: deal ? full : 0 };
    };

    const update = () => {
      const color = selectedColor();
      const chosen = selectedPackCard();
      const chosenIdx = packCards.indexOf(chosen);

      colorInputs.forEach((i) => i.closest('.sq-tress').classList.toggle('is-on', i.checked));
      packCards.forEach((c) => c.classList.toggle('is-on', c === chosen));
      const nameEl = $('#sq-color-name');
      if (nameEl) nameEl.textContent = color;

      let firstUnit = 0;
      packCards.forEach((card, idx) => {
        const info = infoFor(card, idx, color);
        if (idx === 0) firstUnit = info.price / (info.count || 1);
        card.querySelector('.sq-pack-now').textContent = fmt(info.price);
        card.querySelector('.sq-pack-was').textContent = info.was ? fmt(info.was) : '';
        const note = card.querySelector('.sq-pack-note');
        if (info.count > 1) {
          const save = info.was ? info.was - info.price : 0;
          note.textContent = 'Ədədi ' + fmt(info.price / info.count) + (save > 0 ? ' · ' + fmt(save) + ' qənaət' : '');
        } else {
          note.textContent = 'Sınaq üçün';
        }
        const out = info.v && !info.v.available;
        card.classList.toggle('is-off', !!out);
        card.querySelector('input').disabled = !!out;
      });

      const cur = infoFor(chosen, chosenIdx, color);
      const label = chosen.querySelector('.sq-pack-name').textContent + ', ' + color;
      $('#sq-sum-label').textContent = label;
      $('#sq-sum-was').textContent = cur.was ? fmt(cur.was) : '';
      $('#sq-cta-price').textContent = fmt(cur.price);
      $('#sq-bar-price').textContent = fmt(cur.price);
      $('#sq-bar-label').textContent = label;

      const soldOut = cur.v && !cur.v.available;
      orderBtn.disabled = !!soldOut;
      $('#sq-cta-label').textContent = soldOut ? 'Hazırda stokda yoxdur' : 'Sifariş et';

      // Sual-cavab bölməsindəki qiymətlər
      const p1 = packCards[0] ? infoFor(packCards[0], 0, color) : null;
      const last = packCards[packCards.length - 1];
      const p2 = last ? infoFor(last, packCards.length - 1, color) : null;
      const bind = (k, val) => $$('[data-sq="' + k + '"]').forEach((e) => (e.textContent = val));
      if (p1) bind('p1', fmt(p1.price));
      if (p2) { bind('p2', fmt(p2.price)); bind('each2', fmt(p2.price / (p2.count || 1))); }
    };

    colorInputs.concat(packInputs).forEach((i) => i.addEventListener('change', update));

    // Qalereya
    const stage = $('#sq-stage-img');
    const caption = $('#sq-caption');
    $$('.sq-thumb').forEach((btn) => btn.addEventListener('click', () => {
      stage.src = btn.dataset.src;
      stage.alt = btn.dataset.alt || '';
      caption.textContent = btn.dataset.caption || '';
      $('#sq-stage').toggleAttribute('data-portrait', btn.dataset.portrait === 'true');
      $$('.sq-thumb').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
    }));

    // Sifariş
    orderBtn.addEventListener('click', async () => {
      const color = selectedColor();
      const card = selectedPackCard();
      const info = infoFor(card, packCards.indexOf(card), color);
      feedback.textContent = '';
      if (!info.v) { feedback.textContent = 'Məhsul tapılmadı. Səhifəni yeniləyib yenidən cəhd et.'; return; }
      if (!info.v.available) { feedback.textContent = 'Seçilən variant hazırda stokda yoxdur.'; return; }

      const item = { id: info.v.id, quantity: info.qty };
      // Rəng ayrıca variant deyilsə, sifarişdə görünməsi üçün xətt xassəsi kimi göndərilir
      if (!D.colorPos) item.properties = { 'Rəng': color };

      orderBtn.disabled = true;
      $('#sq-cta-label').textContent = 'Sifariş hazırlanır...';
      try {
        // Köhnə qalıq məhsullar sifarişə qarışmasın
        await fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
        const resp = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        if (!resp.ok) throw new Error('Məhsulu sifarişə əlavə etmək mümkün olmadı. Bir az sonra yenidən cəhd et.');

        // Sahibi üçün yoxlama: göstərilən qiymət checkout qiyməti ilə üst-üstə düşürmü
        try {
          const cart = await (await fetch(root + 'cart.js')).json();
          if (cart.total_price !== info.price) {
            console.warn('[sq] Səhifədəki qiymət (' + info.price + ') səbət qiymətindən (' + cart.total_price + ') fərqlənir. Paket endirimini və ya paket variantlarını yoxlayın.');
          }
        } catch (_) {}

        window.location.href = root + 'checkout';
      } catch (e) {
        feedback.textContent = e.message || 'Xəta baş verdi. Yenidən cəhd et.';
        orderBtn.disabled = false;
        update();
      }
    });

    // Geri düyməsi ilə qayıdanda düymə donmuş qalmasın
    window.addEventListener('pageshow', (e) => { if (e.persisted) { orderBtn.disabled = false; update(); } });

    // Mobil alt panel: əsas düymə və yekun blok görünməyəndə göstər
    const bar = $('#sq-bar');
    const watch = [orderBtn, $('.sq-closing')].filter(Boolean);
    if (bar && 'IntersectionObserver' in window) {
      const seen = new Map();
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => seen.set(en.target, en.isIntersecting));
        const anyVisible = [...seen.values()].some(Boolean);
        const pastBuy = orderBtn.getBoundingClientRect().top < 0;
        bar.classList.toggle('is-on', !anyVisible && pastBuy);
        bar.setAttribute('aria-hidden', String(!(!anyVisible && pastBuy)));
      }, { threshold: 0 });
      watch.forEach((el) => io.observe(el));
    }

    update();
  });
})();
